import { FC, useCallback, useMemo } from "react"
import { getIcon } from "utils/icon"
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded"
import {
  Avatar,
  Box,
  Card,
  CardProps,
  IconButton,
  Typography,
  useTheme,
} from "@mui/material"
import { deepmerge } from "@mui/utils"

import { IPostDetail } from "utils/feature"

import { useTranslation } from "providers/i18n"

import { ShopIcon } from "../../icons"
import { isFunction } from "lodash"

export interface IPostMediaCardProps extends Omit<CardProps, "onClick"> {
  data: IPostDetail
  onClick: (data: IPostDetail) => void
}

export const PostMediaCard: FC<IPostMediaCardProps> = ({
  data,
  sx = {},
  onClick,
  ...props
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const {
    root,
    featuredImageContainer,
    featuredImage,
    featuredImageFallback,
    cardContent,
    headerContainer,
    titleContainer,
    titleText,
    iconButton,
  } = theme.components[`PostMediaCard`]?.styleOverrides || {}

  const arrowRightIcon = useMemo(
    () => getIcon(theme?.assets?.arrowRightIcon) || <ChevronRightRoundedIcon />,
    [theme]
  )

  const handleClick = useCallback(() => {
    if (isFunction(onClick)) onClick(data)
  }, [onClick, data])

  return (
    <Card sx={deepmerge(root, sx)} {...props} onClick={handleClick}>
      <Box sx={featuredImageContainer}>
        <Avatar sx={featuredImage} src={data?.featureImage}>
          <ShopIcon sx={featuredImageFallback} />
        </Avatar>
      </Box>
      <Box sx={cardContent}>
        <Box sx={headerContainer}>
          <Box sx={titleContainer}>
            <Typography sx={titleText}>{t(data?.title)}</Typography>
          </Box>
          <IconButton sx={iconButton}>{arrowRightIcon}</IconButton>
        </Box>
      </Box>
    </Card>
  )
}
